import {CheckCircleFilled} from "@ant-design/icons";
import {Input} from "antd";
import {useEffect, useRef, useState} from "react";
import {formatNumber} from "chart.js/helpers";

interface CouponProductItemProps {
    product: any;
    variant: any;
    onToggle: (product: any, variant: any, discountRate: number) => void;
    initialDiscountRate?: number;
    onDiscountRateUpdate: (discountRate: number) => void;
}

const CouponProductItem = ({ product, variant, onToggle, initialDiscountRate = 5, onDiscountRateUpdate }: CouponProductItemProps) => {
    const [discountRate, setDiscountRate] = useState(initialDiscountRate);
    const [isInitial, setIsInitial] = useState(true);
    const timeoutRef = useRef<any>(null);

    const toggleProduct = (product: any, variant: any) => () => {
        onToggle(product, variant, discountRate);
    }

    useEffect(() => {
        if(isInitial) {
            setIsInitial(false);
        } else {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => variant.selected ? onDiscountRateUpdate(discountRate || 0) : onDiscountRateUpdate(0), 1000);
        }
    }, [discountRate, variant.selected]);

    return (
        <div key={product.id} className={`product-item-container ${variant.selected ? 'selected' : ''}`} onClick={toggleProduct(product, variant)}>
            <CheckCircleFilled className="product-checkbox" />
            {product?.image?.src ? <img alt={product.title} src={product.image.src} /> : <div className="no-pic">No picture</div>}
            <div className="title">{product.title} ({variant.title})</div>
            <div className="price">Price: {parseFloat(variant.price).toLocaleString()}</div>
            <div className="max-discount-field-container">
                <div className="label">Discount Rate: </div>
                <div className="field">
                    <Input disabled={!variant.selected} maxLength={3} value={variant.selected ? discountRate || '' : '0'} onClick={(event) => variant.selected ? event.stopPropagation() : toggleProduct(product, variant)} onChange={(event) => setDiscountRate(parseInt(event.target.value))} /><span>%</span>
                </div>
            </div>
        </div>
    );
}

export default CouponProductItem;